import React from 'react';
import './SherlockHomepage.scss';

interface SherlockHomepageProps {
    onTrackerDashboardClick?: () => void;
}

const SherlockHomepage: React.FC<SherlockHomepageProps> = ({ onTrackerDashboardClick }) => {
    return (
        <div className="sherlock-homepage">
            <div className="homepage-content">
                <div className="welcome-section">
                    <h1 className="welcome-title">Welcome to Sherlock</h1>
                </div>
                
                <div className="features-section">
                    <div 
                        className="feature-card clickable" 
                        onClick={onTrackerDashboardClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onTrackerDashboardClick?.();
                            }
                        }}
                    >
                        <div className="feature-icon">📊</div>
                        <h3>Refund Tracker Dashboard</h3>
                        <p>a UI tool that provides visibility into refund processing in payments, offering granular diagnostics to identify, investigate, and resolve stuck or failed refunds processing.</p>
                    </div>
                    
                    <div className="feature-card coming-soon">
                        <div className="feature-icon">🔧</div>
                        <h3>More Dashboards</h3>
                        <p>Additional Tools may be available in the future</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SherlockHomepage;
